import {
  smartRemindersEnglish,
  smartRemindersChinese,
} from './smartRemindersVocabulary';
// Product vocabulary is centralized here, without editing upstream locale files.
import { exceptionEnglish, exceptionChinese } from './exceptionVocabulary';
const en = {
  CLEANUP_ITEM: '{name} · #{id}',
  MAIL_LIBRARY: 'Email originals',
  ALL_ORIGINALS: 'All saved emails',
  MAIL_HINT:
    'Saved originals from Amazon-enabled inboxes. Ordinary email conversations remain in Conversations. Counts are emails, not conversations.',
  WAHA: 'WhatsApp (WAHA)',
  WAHA_DESCRIPTION:
    'Connect WhatsApp with its dedicated proxy and managed API inbox.',
  PROXIES: 'Proxy IP',
  MANAGE: 'Manage WhatsApp',
  MANAGED_HINT:
    'WAHA manages this callback and webhook credentials. Configure agents, assignment and working hours here; use WhatsApp settings for the connection.',
  LOAD_ERROR:
    'Unable to read WhatsApp status. Ordinary inbox operations are unaffected.',
  RETRY: 'Retry',
  LOADING: 'Loading WhatsApp…',
  CLEANUP: 'WAHA inbox cleanup',
  DELETE_HINT:
    'Deleting this WAHA inbox also safely cleans up its integration and background jobs. WhatsApp login and its proxy are retained. This cannot be undone.',
  CLEANUP_ACCEPTED: 'Cleanup requested; wait for confirmation below.',
  DRIFT: 'Connection configuration needs attention',
  ENABLED: 'Message forwarding enabled',
  DISABLED: 'Message forwarding not verified',
  WAIT_REPLY: 'Awaiting agent reply',
  PENDING: 'Pending',
  SNOOZED: 'Snoozed',
};
en.CLEANUP_STATUS = {
  RUNNING: 'In progress',
  DONE: 'Completed',
  NEEDS_REVIEW: 'Needs review',
};
en.CLEANUP_PHASE = {
  DISABLING: 'Disabling forwarding',
  DRAINING: 'Draining jobs',
  PURGING: 'Purging history jobs',
  DELETING_APP: 'Removing integration',
  DELETING_INBOX: 'Deleting inbox',
  VERIFYING_INBOX: 'Verifying deletion',
  FINALIZING: 'Finalizing',
};
const zh = {
  CLEANUP_ITEM: '{name} · #{id}',
  MAIL_LIBRARY: '邮件原件',
  ALL_ORIGINALS: '全部已保存邮件',
  MAIL_HINT:
    '这里保存已启用亚马逊归档邮箱的邮件原件；普通邮箱的客服记录请到“会话”查看。此处数量按邮件封数统计，不是会话数。',
  WAHA: 'WhatsApp（WAHA）',
  WAHA_DESCRIPTION: '绑定专属代理、扫码连接 WhatsApp，并建立托管收件箱。',
  PROXIES: '代理 IP',
  MANAGE: '管理 WhatsApp',
  MANAGED_HINT:
    '回调地址与签名凭据由 WAHA 管理，此处不可修改。客服成员、分配和工作时间仍在本页设置；连接与代理请到 WhatsApp 管理。',
  LOAD_ERROR: 'WhatsApp 状态读取失败，普通收件箱操作不受影响。',
  RETRY: '重试',
  LOADING: '正在加载 WhatsApp…',
  CLEANUP: 'WAHA 收件箱清理',
  DELETE_HINT:
    '删除此 WAHA 收件箱时，将安全清理消息集成和后台任务，保留 WhatsApp 登录和代理绑定。删除不可撤销。',
  CLEANUP_ACCEPTED: '已提交清理，请等待下方状态确认。',
  DRIFT: '连接配置不一致，待核对',
  ENABLED: '消息转发已启用',
  DISABLED: '消息转发未验证',
  WAIT_REPLY: '等待客服回复',
  PENDING: '待处理',
  SNOOZED: '已推迟',
};
zh.CLEANUP_STATUS = {
  RUNNING: '清理中',
  DONE: '已完成',
  NEEDS_REVIEW: '需要核对',
};
zh.CLEANUP_PHASE = {
  DISABLING: '关闭转发',
  DRAINING: '等待任务结束',
  PURGING: '清理历史任务',
  DELETING_APP: '移除集成',
  DELETING_INBOX: '删除收件箱',
  VERIFYING_INBOX: '确认删除结果',
  FINALIZING: '完成解绑',
};
en.COUNTRY_INFO = {
  EDIT: 'Choose country',
  UNKNOWN: 'Unable to identify',
  LOADING: 'Identifying…',
  AUTO: 'Automatic identification',
  SAVE: 'Save',
  CANCEL: 'Cancel',
  SAVE_ERROR: 'Unable to save. Please try again.',
  SOURCE: {
    manual: 'Manually selected',
    order_shipping: 'Order shipping country',
    order_marketplace: 'Order marketplace',
    language: 'Language inferred · country unconfirmed',
    unknown: 'Country / language',
    conflict: 'Order countries differ · select manually',
  },
};
zh.COUNTRY_INFO = {
  EDIT: '选择国家',
  UNKNOWN: '无法识别',
  LOADING: '正在识别…',
  AUTO: '自动识别',
  SAVE: '保存',
  CANCEL: '取消',
  SAVE_ERROR: '保存失败，请重试。',
  SOURCE: {
    manual: '手动匹配',
    order_shipping: '订单收货国家',
    order_marketplace: '订单站点',
    language: '语言推测 · 国家待确认',
    unknown: '国家 / 语言',
    conflict: '订单国家不一致 · 请手动选择',
  },
};
en.EMAIL_HISTORY = {
  NO_SENT:
    'A Sent folder was not identified. Coverage is limited to the selected accessible folders.',
  TITLE: 'Email history',
  START: 'Import recent 90 days',
  EXTEND: 'Import previous 90 days',
  RETRY: 'Resume',
  REFRESH: 'Refresh status',
  COUNTS:
    'Task added {imported} · Already present {existing} · Deleted exclusions {excluded}',
  PLACEMENT:
    'Retained in this range: {current} in this conversation · {other} in other accessible conversations',
  OTHER_CONVERSATION: '#{id} · {count} emails',
  MORE_CONVERSATIONS: 'Showing the first 20 other conversations.',
  PARTIAL:
    'Some messages were skipped because of size, identity or thread ambiguity.',
  COMPLETE_NOTE:
    'This search range is complete. Load imported messages, then scroll up for older history. Other threads remain separate.',
  LOAD_MESSAGES: 'Load imported messages',
  LIVE_PENDING:
    'Recent incoming mail is handled by normal delivery and is not silently imported. Some recent mail in other folders may require a later sync.',
  ERROR: 'Unable to load or start history sync. Please retry.',
  STATE: {
    idle: 'New customer emails trigger a background history search.',
    queued: 'Waiting to import history',
    running: 'Importing history',
    complete: 'Search range completed',
    failed: 'Import paused after an error',
    cancelled: 'Import stopped because its source changed',
  },
};
zh.EMAIL_HISTORY = {
  NO_SENT: '未识别到已发送文件夹，本次仅覆盖已选的可访问文件夹。',
  TITLE: '邮件历史',
  START: '补齐最近 90 天',
  EXTEND: '继续补齐更早 90 天',
  RETRY: '继续同步',
  REFRESH: '刷新进度',
  COUNTS:
    '本次任务新增 {imported} 封 · 已存在 {existing} 封 · 删除排除 {excluded} 封',
  PLACEMENT:
    '本范围保留历史：当前会话 {current} 封 · 其他可访问会话 {other} 封',
  OTHER_CONVERSATION: '#{id} · {count} 封',
  MORE_CONVERSATIONS: '仅列出前 20 个其他会话。',
  PARTIAL: '部分邮件因体积、身份或线程归属不明确而跳过。',
  COMPLETE_NOTE:
    '本次范围检索完成。可加载补入消息，向上滚动查看更早历史；其他线程保持独立。',
  LOAD_MESSAGES: '加载补入消息',
  LIVE_PENDING:
    '近期来信由正常收信处理；其他文件夹的近期邮件可能需要后续补齐。',
  ERROR: '历史同步请求失败，请重试。',
  STATE: {
    idle: '客户新邮件到达后，将在后台补齐历史。',
    queued: '等待补齐历史',
    running: '正在补齐历史',
    complete: '本次范围检索完成',
    failed: '同步遇到错误，已暂停',
    cancelled: '来源变化或会话删除，同步已停止',
  },
};
en.BULK_READ = {
  LABEL: 'Mark as read',
  SUCCESS: 'Marked {count} conversations as read.',
  PARTIAL:
    'Marked {count} as read; {failed} failed and remain selected. Please retry.',
};
zh.BULK_READ = {
  LABEL: '标记已读',
  SUCCESS: '已将 {count} 个对话标记为已读。',
  PARTIAL: '已标记 {count} 个，失败 {failed} 个；失败对话仍保留勾选，请重试。',
};
export function withBorderchatVocabulary(messages, chinese = false) {
  const words = chinese ? zh : en;
  const result = {
    ...messages,
    BORDERCHAT: {
      ...words,
      SMART_REMINDERS: chinese ? smartRemindersChinese : smartRemindersEnglish,
      EXCEPTIONS: chinese ? exceptionChinese : exceptionEnglish,
    },
  };
  if (!chinese) return result;
  result.SIDEBAR = {
    ...messages.SIDEBAR,
    INBOX: words.MAIL_LIBRARY,
    UNATTENDED_CONVERSATIONS: words.WAIT_REPLY,
  };
  result.CHAT_LIST = {
    ...messages.CHAT_LIST,
    UNATTENDED_HEADING: words.WAIT_REPLY,
    CHAT_STATUS_FILTER_ITEMS: {
      ...messages.CHAT_LIST.CHAT_STATUS_FILTER_ITEMS,
      pending: { TEXT: words.PENDING },
      snoozed: { TEXT: words.SNOOZED },
    },
  };
  return result;
}
